/**
 * @imports
 */
import Api from '../../../Api';
import { fnComPdaEquipoSuministradoQuery } from './fnComPdaEquipoSuministrado';

/**
 *
 * @param {{ desde?: string, hasta?: string, search?: string }} opts
 * @returns
 */
export function fnComPdasServicioQuery(opts) {
  //
  const q = {
    model: 'ComOrdenService',

    attributes: [
      'iId',
      'sDescripcion',
      'dCantidad',
      'dPrecio',
      'dFechaValida',
      'sEstatusServicio',
      [{ 'literal': '(ComOrdenService.dCantidad * ComOrdenService.dPrecio)' }, 'dImporte']
    ],

    include: [
      {
        as: 'medida',
        required: true,
        attributes: ['sNombre'],
      },
      {
        as: 'orden',
        required: true,
        attributes: [
          'sConsecutivo',
          'dFechaEntrega',
        ],

        include: [
          {
            as: 'moneda',
            required: true,
            attributes: ['sCodigo'],
          },
        ],

        where: {
          iActivo: true,
          eEstado: 'AUTORIZADA',
        }
      },

      {
        as: 'requisicion',
        attributes: [
          'mComentarios',
        ],
        required: true,
        where: {
          iActivo: true,
          iMaquinaria: true,
          eStatus: 'RECEPCIONADA',
        },
      },
    ],

    where: {
      iActivo: true,
      '$`orden`.iId_proveedor$': Api.getProviderId(),
    },

    order: [['iId', 'DESC']],
  };

  // incluir (left join) periodos a consulta (pda de servicio) base
  q.include.push(fnComPdaEquipoSuministradoQuery());
  // query oficial (raw)
  q.where['$or'] = [];

  // fechas
  if (opts.desde || opts.hasta) {
    const dateFilter = {};
    if (opts.desde) { dateFilter['$gte'] = opts.desde; }
    if (opts.hasta) { dateFilter['$lte'] = opts.hasta; }
    q.where['$or'].push({ '$`orden`.dHoraAutoriza$': dateFilter });
  }

  // busqueda
  if (typeof opts.search === 'string' && opts.search.length > 0) {
    const likeSearch = { $like: `%${opts.search}%` };
    q.where['$or'] = [
      { '$`orden`.sConsecutivo$': likeSearch },
      { '$`ComOrdenService`.sDescripcion$': likeSearch },
      { '$`orden`.sObservaciones$': likeSearch },
      { '$`orden`.sOtrosCargos$': likeSearch },
      { '$`orden`.sLugarEntrega$': likeSearch },
    ];
  }

  return q;
}
